import type { Sector } from "~/modules/sector/models/Sector.interface";

export function findSectorInSectorTree(
  sectorTree: Sector,
  targetSectorCode: number,
): Sector | undefined {
  if (sectorTree.code === targetSectorCode) {
    return sectorTree;
  }

  for (const child of sectorTree.children) {
    if (child.code === targetSectorCode) {
      return child;
    }

    if (child.children.length > 0) {
      const foundSector: Sector | undefined = findSectorInSectorTree(
        child,
        targetSectorCode,
      );
      if (foundSector) {
        return foundSector;
      }
    }
  }
}
